

// components/UserManagement.jsx
import React, { useEffect, useRef, useState } from "react";
import $ from "jquery";
import "datatables.net-bs5";
import "datatables.net-responsive-dt";
import "datatables.net-select-dt";
import 'datatables.net-dt';

// import DataTable from "datatables.net-react";
// import DT from 'datatables.net-bs5';
import "bootstrap/dist/css/bootstrap.min.css";
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

import 'bootstrap/dist/css/bootstrap.min.css';
 
import 'datatables.net-bs5/css/dataTables.bootstrap5.min.css'

import 'datatables.net-dt/css/dataTables.dataTables.min.css';
import "datatables.net-responsive-dt/css/responsive.dataTables.css";

import * as bootstrap from 'bootstrap';

 

import { getAllUsers } from "../../services/dashbboard/adminReportService";

import { Card, Badge, Tabs, Tab } from "react-bootstrap";
import Util from "../../components/Util";

const BASE_URL = process.env.REACT_APP_BASE_URL;

const CURRENCIES = ["IRR", "USD", "EUR", "AED"];

const PAYMENT_STATUS = {
  success: { label: "موفق", bg: "success" },
  pending: { label: "در انتظار پرداخت", bg: "warning" },
  failed: { label: "ناموفق", bg: "danger" },
};

const CHANNELS = { sms: "پیامک", bale: "بله", whatsapp: "واتساپ", telegram: "تلگرام", push: "نوتیفیکیشن" };
const SEASONS = { spring: "بهار", summer: "تابستان", fall: "پاییز", winter: "زمستان" };
const POT_SIZES = { xsmall: "خیلی کوچک", small: "کوچک", medium: "متوسط", large: "بزرگ", xlarge: "خیلی بزرگ" };

const formatDateTime = (date) =>
  date
    ? new Date(date).toLocaleString("fa-IR", {
        hour12: false,
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
      })
    : "-";

const formatFrequency = (setting) => {
  if (!setting) return "-";
  const times = setting.timesPerDay > 1 ? ` - ${setting.timesPerDay} بار در روز` : "";
  return setting.frequencyType === "everyXDays"
    ? `هر ${setting.intervalDays} روز یکبار${times}`
    : `هر روز${times}`;
};


// 🔹 لیست پرداخت‌ها
const PaymentList = ({ payments, emptyText }) => {
  if (!payments.length) return <p className="text-muted">{emptyText}</p>;

  return (
    <div className="payments-list">
      {payments.map((payment) => {
        const status = PAYMENT_STATUS[payment.status] || { label: payment.status, bg: "secondary" };
        return (
          <div className="payment-item" key={payment._id}>
            <div className="d-flex justify-content-between align-items-center mb-2">
              <strong>{payment.plan?.name || "پلن نامشخص"}</strong>
              <Badge bg={status.bg}>{status.label}</Badge>
            </div>
            <div className="payment-row">
              <span className="label">مبلغ:</span>
              <span className="value">
                {payment.amount?.toLocaleString()} {CURRENCIES[payment.currency] || ""}
              </span>
            </div>
            {payment.plan && (
              <div className="payment-row">
                <span className="label">مشخصات پلن:</span>
                <span className="value">
                  {payment.plan.durationDays} روز - {payment.plan.maxReminders} یادآور
                </span>
              </div>
            )}
            <div className="payment-row">
              <span className="label">درگاه:</span>
              <span className="value">{payment.gateway}</span>
            </div>
            {payment.discount && (
              <div className="payment-row">
                <span className="label">کد تخفیف:</span>
                <span className="value">
                  {payment.discount.code} ({payment.discount.percent}٪)
                </span>
              </div>
            )}
            <div className="payment-row">
              <span className="label">درخواست:</span>
              <span className="value">{formatDateTime(payment.requestedAt)}</span>
            </div>
            {payment.paidAt && (
              <div className="payment-row">
                <span className="label">پرداخت:</span>
                <span className="value">{formatDateTime(payment.paidAt)}</span>
              </div>
            )}
            {payment.refId && (
              <div className="payment-row">
                <span className="label">شماره مرجع:</span>
                <span className="value">{payment.refId}</span>
              </div>
            )}
            {payment.status !== "success" && payment.description && (
              <div className="payment-row">
                <span className="label">توضیحات:</span>
                <span className="value text-danger">{payment.description}</span>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};


// 🔹 کارت گیاه + یادآور جاری (مشابه صفحه «یادآوری‌های من» کاربر)
const UserPlantReminderCard = ({ item }) => (
  <Card className="mb-3">
    <div className="row g-0">
      <div className="col-md-3 image-footer-parent">
        {item.image ? (
          <Card.Img src={BASE_URL + item.image} alt={item.plantName} />
        ) : (
          <div className="bg-light h-100" style={{ minHeight: 120 }} />
        )}
        <div className="image-footer">
          <p><b>{item.plantName || "گیاه حذف شده"}</b></p>
          <p>{item.plantGroupName}</p>
        </div>
      </div>
      <div className="col-md-9">
        <Card.Body>
          <Card.Title>{item.MyTitle || item.plantName || "N/A"}</Card.Title>
          {item.note && <Card.Subtitle className="mb-2 text-muted">{item.note}</Card.Subtitle>}

          {!item.isActive ? (
            <div className="text-muted mt-2">یادآور غیرفعال است</div>
          ) : item.nextWatering ? (
            <div className="text-success mt-2">
              <strong>آبیاری بعدی: </strong>
              {formatDateTime(item.nextWatering)}
              <span className="text-muted"> ({Util.timeUntil(item.nextWatering).message})</span>
            </div>
          ) : (
            <div className="text-danger mt-2">یادآور جاری ندارد</div>
          )}

          <div className="small mt-2">
            <div>
              <span className="text-muted">برنامه: </span>
              {formatFrequency(item.setting)}
              {item.setting?.amountPerTime ? ` - ${item.setting.amountPerTime} میلی‌لیتر` : ""}
            </div>
            <div>
              <span className="text-muted">گلدان: </span>
              {POT_SIZES[item.potSize] || item.potSize} - {item.isInDoor ? "فضای داخلی" : "فضای باز"}
              {item.setting?.season ? ` - فصل ${SEASONS[item.setting.season] || item.setting.season}` : ""}
            </div>
            <div>
              <span className="text-muted">کانال‌ها: </span>
              {(item.channels || []).map((c) => CHANNELS[c] || c).join("، ") || "-"}
            </div>
            <div>
              <span className="text-muted">آخرین ارسال: </span>
              {formatDateTime(item.lastSentAt)}
              <span className="text-muted"> | آخرین آبیاری: </span>
              {formatDateTime(item.lastWateredAt)}
            </div>
          </div>
        </Card.Body>
      </div>
    </div>
  </Card>
);

const UserManagement = () => {
  const tableRef = useRef(null);
  const [users, setUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);

  const payments = selectedUser?.payments || [];
  const successPayments = payments.filter((p) => p.status === "success");
  const otherPayments = payments.filter((p) => p.status !== "success");

  // گیاهانی که یادآور جاری دارند اول (نزدیک‌ترین زمان)، بقیه آخر
  const userPlants = [...(selectedUser?.userPlants || [])].sort((a, b) => {
    if (!a.nextWatering) return 1;
    if (!b.nextWatering) return -1;
    return new Date(a.nextWatering) - new Date(b.nextWatering);
  });

  useEffect( () => {

    const resp =  getAllUsers().then(data=>{
        setUsers(data)
    });


  }, []);

  useEffect(() => {
    if (users.length > 0) {
      const table = $(tableRef.current).DataTable({
        destroy: true,
        data: users,
        columns: [
          { title: "شناسه", data: "identity" },
          { title: "شماره موبایل", data: "phone" },
          { title: "آخرین IP", data: "lastLoginIP" },
          {
            title: "آخرین ورود",
            data: "lastLoginDate",
            render: (data) =>
              data ? new Date(data).toLocaleString("fa-IR") : "-",
          },

           {
            title: "یادآور",
            data: "reminders",
            render: (data,type,row) =>
              row.reminders.length,
          },


           {
            title: "پرداختها",
            data: "payments",
            render: (data,type,row) =>
              row.payments.length,
          },


            {
            title: "گیاهان",
            data: "userPlants",
            render: (data,type,row) =>
              row.userPlants.length,
          },

          


          {
            title: "فعال",
            data: "isEnableAccount",
            render: (data) => (data ? "✅" : "❌"),
          },
          {
            title: "مدیر",
            data: "isAdministrator",
            render: (data) => (data ? "🛡️" : "-"),
          },
          {
            title: "عملیات",
            data: null,
            orderable: false,
            render: (data, type, row) =>
              `<button class="btn btn-sm btn-primary view-user" data-id="${row.identity}">گزارش</button>`,
          },
        ],
        responsive: true,
      });

      $(tableRef.current).on("click", ".view-user", function () {
        const identity = $(this).data("id");
        const user = users.find((u) => u.identity === identity);
        setSelectedUser(user);
        const modal = new bootstrap.Modal("#userModal");
        modal.show();
      });

      return () => {
        table.destroy(true);
      };
    }
  }, [users]);

  return (
    <div className="container">

      

      <h3>مدیریت کاربران</h3>
      <table ref={tableRef} className="table table-striped" style={{ width: "100%" }} />

      {/* Modal for User Details */}
      <div className="modal fade" id="userModal" tabIndex="-1" aria-hidden="true">
        <div className="modal-dialog modal-lg modal-dialog-scrollable">
          <div className="modal-content">
            <div className="modal-header">
              <button type="button" className="btn-close" data-bs-dismiss="modal" />
              <h5 className="modal-title">گزارشات کاربر: {selectedUser?.phone}</h5>
            </div>
            <div className="modal-body">
              <ul className="nav nav-tabs" id="reportTabs" role="tablist">
                <li className="nav-item" role="presentation">
                  <button
                    className="nav-link active"
                    id="plans-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#plans"
                    type="button"
                    role="tab"
                  >
                    پلن‌ کاربر
                  </button>
                </li>
                <li className="nav-item" role="presentation">
                  <button
                    className="nav-link"
                    id="purchases-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#purchases"
                    type="button"
                    role="tab"
                  >
                    خریدها
                  </button>
                </li>
                <li className="nav-item" role="presentation">
                  <button
                    className="nav-link"
                    id="schedules-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#schedules"
                    type="button"
                    role="tab"
                  >
                    زمان‌بندی‌ها
                  </button>
                </li>
              </ul>
              <div className="tab-content mt-3" id="reportTabsContent">
                <div className="tab-pane fade show active" id="plans" role="tabpanel">


                    <div className="credit-box">
                      <div className="credit-item">
                        <div className="credit-label">تعداد یادآور مجاز</div>
                        <div className="credit-value">{selectedUser?.maxReminder}</div>
                      </div>

                      <div className="credit-item">
                        <div className="credit-label">اعتبار حساب کاربری</div>
                        <div className="credit-value">
                          {selectedUser?.validDueDate
                            ? new Date(selectedUser.validDueDate).toLocaleDateString('fa-IR')
                            : "-"}
                        </div>
                      </div>
                    </div>



                   



                </div>
                <div className="tab-pane fade" id="purchases" role="tabpanel">

                  <Tabs key={selectedUser?._id} defaultActiveKey="success" className="mb-3" justify>
                    <Tab eventKey="success" title={`خریدهای موفق (${successPayments.length})`}>
                      <PaymentList payments={successPayments} emptyText="خرید موفقی برای این کاربر ثبت نشده است." />
                    </Tab>
                    <Tab eventKey="other" title={`سایر تراکنش‌ها (${otherPayments.length})`}>
                      <PaymentList payments={otherPayments} emptyText="تراکنش ناموفق یا در انتظاری ثبت نشده است." />
                    </Tab>
                  </Tabs>

                </div>
                <div className="tab-pane fade" id="schedules" role="tabpanel">

                  {userPlants.length ? (
                    userPlants.map((item) => <UserPlantReminderCard key={item._id} item={item} />)
                  ) : (
                    <p className="text-muted">این کاربر هنوز گیاه یا یادآوری تعریف نکرده است.</p>
                  )}

                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button className="btn btn-secondary" data-bs-dismiss="modal">
                بستن
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserManagement;
